import { render, staticRenderFns } from "./search-content.vue?vue&type=template&id=7c8ba83e&"
import script from "./search-content.vue?vue&type=script&lang=ts&"
export * from "./search-content.vue?vue&type=script&lang=ts&"
import style0 from "./search-content.vue?vue&type=style&index=0&id=7c8ba83e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports